import React from 'react';
import { getUserId } from './utils';
import Todo from './Todo';
import { v4 as uuid } from "uuid";

function TodoList({ categories, activeCategory, todoLists, setTodoLists, deleteTodo }) {
    return (
        <ul className="list-group list-group-flush my-3">
            {(categories[activeCategory] && todoLists[categories[activeCategory]] && todoLists[categories[activeCategory]].length > 0) ? (
                todoLists[categories[activeCategory]].map((todo, index) => (
                    <Todo
                        key={uuid()}
                        todo={todo}
                        index={index}
                        onCheck={() => {
                            const userId = getUserId();
                            const categoryName = categories[activeCategory];
                            const updatedLists = { ...todoLists };
                            updatedLists[categoryName] = updatedLists[categoryName].map((item, i) =>
                                i === index ? { ...item, checked: !item.checked } : item
                            );
                            setTodoLists(updatedLists);
                            localStorage.setItem(userId, JSON.stringify(updatedLists));
                        }}
                        onDelete={() => deleteTodo(index)}
                    />
                ))
            ) : (
                <div className="text-center text-muted my-3">
                    <i className="bi bi-cup-hot-fill" style={{ fontSize: "3rem" }}></i>
                    <p>まだリストがありません</p>
                </div>
            )}
        </ul>
    );
}

export default TodoList;
